import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useProjects } from '../../hooks/useProjects'
import { Button } from '../Common/Button'
import { Loading } from '../Common/Loading'
import { ProjectCard } from './ProjectCard'
import { CreateProjectModal } from './CreateProjectModal'
import { Plus, Trash2, Eye, Edit2 } from 'lucide-react'
import toast from 'react-hot-toast'

export const ProjectList = () => {
  const navigate = useNavigate()
  const { projects, loading, fetchProjects, deleteProject } = useProjects()
  const [showCreateModal, setShowCreateModal] = useState(false)

  useEffect(() => {
    fetchProjects()
  }, [fetchProjects])

  const handleDelete = async (cardId) => {
    if (window.confirm('Вы уверены, что хотите удалить проект?')) {
      await deleteProject(cardId)
      await fetchProjects()
    }
  }

  if (loading) return <Loading message="Загрузка проектов..." />

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-3xl font-bold">Мои проекты</h1>

        {projects.length > 0 ? (
            <Button
              variant="primary"
              size="lg"
              onClick={() => setShowCreateModal(true)}
              className="flex items-center gap-2"
            >
              <Plus size={20} />
              Загрузить документ
            </Button>
        ) : (
            <div></div>
        )}
      </div>

      {projects.length === 0 ? (
        <div className="text-center py-12">
          <p className="text-gray-600 mb-4">Нет проектов</p>
          <Button
            variant="primary"
            onClick={() => setShowCreateModal(true)}
          >
            Загрузить документ
          </Button>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {projects.map((project) => (
            <div
              key={project.id}
              className="bg-white rounded-lg shadow hover:shadow-lg transition-shadow"
            >
              <div className="p-6">
                <h3 className="text-lg font-semibold mb-2 truncate">
                  {project.file_name}
                </h3>
                <p className="text-sm text-gray-600 mb-4">
                  Страниц: {project.total_pages}
                </p>
                <div className="flex gap-2">
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={() => navigate(`/projects/${project.id}`)}
                    className="flex-1 flex items-center justify-center gap-2"
                  >
                    <Eye size={16} />
                    Просмотр
                  </Button>
{/*                   <Button */}
{/*                     variant="secondary" */}
{/*                     size="sm" */}
{/*                     onClick={() => navigate(`/projects/${project.id}/edit`)} */}
{/*                     className="flex-1 flex items-center justify-center gap-2" */}
{/*                   > */}
{/*                     <Edit2 size={16} /> */}
{/*                     Редактировать */}
{/*                   </Button> */}
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => handleDelete(project.id)}
                    className="flex items-center justify-center gap-2"
                  >
                    <Trash2 size={16} />
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      <CreateProjectModal
        isOpen={showCreateModal}
        onClose={() => setShowCreateModal(false)}
        onSuccess={(response) => {
          setShowCreateModal(false)
          fetchProjects()
          // Сразу переходим на страницу просмотра документа,
          // где виден прогресс загрузки листов и автоклассификации
          const cardId = response?.id || response?.card_id || response?.data?.id
          if (cardId) {
            navigate(`/projects/${cardId}`)
          }
        }}
      />
    </div>
  )
}
